import { Select, Input, Button, Switch } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { validateWebsite } from '@/utils/common'
import UploadBigFile from '@/views/components/uploadBigFile'
import { $terms } from '@/locale'

import './style.less'

export function validateWebsiteError(value) {
  if (!value) {
    return '请输入网址'
  }
  if (!validateWebsite(value)) {
    return '网址格式不正确，请重新输入'
  }
  return ''
}

const WebSite = props => {
  const prefixCls = 'bytfc-smsc'
  const fileFormat = ['txt', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'wps', 'zip']
  const fileSize = 500

  const { addons, schema } = props
  const haveSignCode = schema.haveSignCode

  const [websiteError, setWebsiteError] = useState('')
  const [uploadError, setUploadError] = useState('')

  let defaultTypeValue = 'default'
  let defaultWebsiteValue = ''
  let defaultShowQrCode = false
  const defaultDownloadValue = []
  const fileUrl = id => {
    return window.domainConfig.fileServer + '/' + id
  }
  if (props.value !== 'default' && props.value && 'key' in props.value) {
    const obj = props.value
    defaultTypeValue = obj.key
    if ('showQrCode' in obj) {
      defaultShowQrCode = obj.showQrCode
    }
    switch (obj.key) {
      case 'website':
        defaultWebsiteValue = obj.value
        break
      case 'download':
        if (Array.isArray(obj.value)) {
          obj.value.forEach(item => {
            defaultDownloadValue.push({
              uid: item.fileId,
              name: `${item.fileName}${item.extension}`,
              status: 'done',
              url: fileUrl(item.fileId),
              file: item
            })
          })
        }
        break
      default:
    }
  }
  const [typeValue, setTypeValue] = useState(defaultTypeValue)
  const [websiteValue, setWebsiteValue] = useState(defaultWebsiteValue)
  const [downloadValue, setDownloadValue] = useState(defaultDownloadValue)
  const [showQrCode, setShowQrCode] = useState(defaultShowQrCode)

  const setComponentsValue = (key, v = '', showQrCode = false) => {
    const { dataPath, setValueByPath } = addons
    setValueByPath(dataPath, {
      key,
      showQrCode,
      value:
        key === 'download' && Array.isArray(v)
          ? v.map(item => {
              return {
                ...item.file
              }
            })
          : v
    })
  }
  return (
    <div className={prefixCls}>
      <Select
        value={typeValue}
        className={`${prefixCls}-select`}
        options={[
          { label: $terms('展示系统默认页'), value: 'default' },
          { label: $terms('跳转网页'), value: 'website' },
          { label: $terms('下载文档'), value: 'download' }
        ]}
        onChange={value => {
          setTypeValue(value)
          let v = ''
          if (value === 'website') {
            v = websiteValue
          } else if (value === 'download') {
            v = defaultDownloadValue
          }
          setComponentsValue(value, v, showQrCode)
        }}
      />
      {haveSignCode && ['default', 'download'].includes(typeValue) ? (
        <div className={`${prefixCls}-code`}>
          <label>{$terms('展示签到二维码')}</label>
          <Switch
            checked={showQrCode}
            onChange={v => {
              setShowQrCode(v)
              setComponentsValue(typeValue, typeValue === 'website' ? websiteValue : defaultDownloadValue, v)
            }}
          ></Switch>
        </div>
      ) : (
        ''
      )}
      {typeValue === 'website' && (
        <div className={`${prefixCls}-website`}>
          <p className={`${prefixCls}-title`}>
            <span className="fr-label-required"> *</span>
            {$terms('网页地址')}
          </p>
          <div>
            <Input
              value={websiteValue}
              className={websiteError && 'fr-item-status-error'}
              placeholder={$terms('请输入网址')}
              onChange={event => {
                const target = event.target
                const value = target.value
                setComponentsValue(typeValue, value, showQrCode)
                setWebsiteValue(value)
                setWebsiteError(validateWebsiteError(value))
              }}
            />
          </div>
          {websiteError && <div className="error-message">{websiteError}</div>}
        </div>
      )}
      {typeValue === 'download' && (
        <div className={`${prefixCls}-download`}>
          <p className={`${prefixCls}-title`}>
            <span className="fr-label-required"> *</span>
            {$terms('上传文档')}
          </p>
          <p className={`${prefixCls}-desc`}>
            {$terms('请上传不超过')} {fileSize}MB {fileFormat.join(',')} {$terms('格式的文件')}
          </p>
          <div>
            <UploadBigFile
              maxFileSize={fileSize}
              fileFormat={fileFormat}
              fileList={downloadValue}
              onChange={fileObj => {
                setDownloadValue([fileObj])
                setUploadError('')
                if (fileObj.status === 'done') {
                  setComponentsValue(typeValue, [fileObj], showQrCode)
                }
              }}
              onError={error => {
                setUploadError(error)
              }}
              onRemove={fileObj => {
                const index = downloadValue.findIndex(file => file.uid === fileObj.uid)
                if (index < 0) {
                  return
                }
                downloadValue.splice(index, 1)
                setDownloadValue([...downloadValue])
                setComponentsValue(typeValue, [...downloadValue], showQrCode)
              }}
            >
              <Button>
                <PlusOutlined />
                {downloadValue.length ? $terms('重新上传') : $terms('上传文档')}
              </Button>
            </UploadBigFile>
          </div>
          {uploadError && <div className="error-message">{uploadError}</div>}
        </div>
      )}
    </div>
  )
}

export default WebSite
